module.exports = __webpack_public_path__ + "static/media/logo-si.f8ad35c7.png";